import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { GET_GOLF_COURSE_UNAVAILABLE, GET_GOLF_COURSE_UNAVAILABLE_SUCCESS, GET_GOLF_COURSE_UNAVAILABLE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getGolfCourseUnavailable({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-unavailable`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GOLF_COURSE_UNAVAILABLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GOLF_COURSE_UNAVAILABLE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GOLF_COURSE_UNAVAILABLE_ERROR, payload: error });
  }
}

export function* watchGetGolfCourseUnavailable() {
  yield takeEvery(GET_GOLF_COURSE_UNAVAILABLE, getGolfCourseUnavailable);
}

function* getGolfCourseUnavailableSaga() {
  yield all([fork(watchGetGolfCourseUnavailable)]);
}

export default getGolfCourseUnavailableSaga;
